import React from 'react'
import ScrumOrScrumbut from '../components/landing-pages/scrum-or-scrumbut'

export default ()=>{
    return <ScrumOrScrumbut/>
}